import type { AxiosError } from 'axios';

export const isAuthenticationError = (error: AxiosError): boolean => {
  return (
    error.response?.status === 401 &&
    (error.response?.data as { code?: string })?.code ===
      'AUTHENTICATION_FAILED'
  );
};
